import React, { useEffect, useState } from "react";

const AppAlert = ({ type, message, delay = 5 }) => {
  const [display, setDisplay] = useState(true);

  useEffect(() => {
    setDisplay(true);
    setTimeout(() => setDisplay(false), delay * 1000);
    // eslint-disable-next-line
  }, []);

  return (
    display && (
      <div
        className={`fixed z-50 top-0 left-0 grid place-items-center w-screen h-screen bg-black/50`}
      >
        <div
          className={`flex items-center gap-6 w-[300px] md:w-[400px] lg:w-[450px] p-3 lg:p-7 border-2 text-primary bg-white ${
            type === "success"
              ? "border-green-850"
              : type === "error"
              ? "border-red-850"
              : ""
          }`}
        >
          <div
            className={`h-8 w-8 grid place-items-center ${
              type === "success"
                ? "bg-green-850"
                : type === "error"
                ? "bg-red-850"
                : ""
            }`}
          >
            <i
              className="iconify text-white text-3xl"
              data-icon={`${
                type === "success"
                  ? "gg:check"
                  : type === "error"
                  ? "uil:exclamation"
                  : ""
              }`}
            />
          </div>
          <div className="grid lg:gap-2 w-full">
            <p className="text-2xl lg:text-4xl uppercase">{type}</p>
            <div
              className={`w-[50%] border mb-3 ${
                type === "success"
                  ? "border-green-850"
                  : type === "error"
                  ? "border-red-850"
                  : ""
              }`}
            />
            {message}
          </div>
        </div>
      </div>
    )
  );
};

export default AppAlert;
